import { stripHtml } from "./seoUtils";

const SHOP_BASE_URL = "https://myprivatechemist.com";
const SITE_BASE_URL = "https://myprivatechemist.com";

const MPC_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Longcroft House, 2-8 Victoria Avenue",
  addressLocality: "London",
  postalCode: "EC2M 4NS",
  addressCountry: "GB",
};

const MPC_MEDICAL_ORGANIZATION = {
  "@type": "MedicalOrganization",
  name: "My Private Chemist",
  url: `${SITE_BASE_URL}/`,
  logo: `${SHOP_BASE_URL}/logo.png`,
  address: MPC_ADDRESS,
};

export function buildOrganizationSchema() {
  return { ...MPC_MEDICAL_ORGANIZATION };
}

export function buildWebSiteSchema() {
  return {
    "@type": "WebSite",
    name: "My Private Chemist",
    url: `${SITE_BASE_URL}/`,
    publisher: {
      "@type": "Organization",
      name: "My Private Chemist",
      logo: `${SHOP_BASE_URL}/logo.png`,
    },
  };
}

function joinUrl(base, path) {
  const normalizedBase = base.replace(/\/+$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

/**
 * @param {object} test - Blood test API record
 * @param {string} slug - URL slug
 * @returns {object|null}
 */
export function buildBloodTestSchema(test, slug) {
  if (!test?.name || test.price == null || !slug) {
    return null;
  }

  const pageUrl = joinUrl(SHOP_BASE_URL, `/blood-tests/${slug}`);
  const imageUrl = joinUrl(SHOP_BASE_URL, "/assets/icons/blood-single-up.png");

  return {
    "@context": "https://schema.org",
    "@type": ["MedicalTest", "Service"],
    name: test.name,
    description:
      stripHtml(test.shortDescription || test.description || "") || undefined,
    url: pageUrl,
    image: imageUrl,
    identifier: test.unique_code || test.uniqueCode || undefined,
    relevantSpecialty: "https://schema.org/LaboratoryScience",
    provider: MPC_MEDICAL_ORGANIZATION,
    offers: {
      "@type": "Offer",
      url: pageUrl,
      priceCurrency: "GBP",
      price: String(test.price),
      availability: "https://schema.org/InStock",
    },
  };
}

/**
 * @param {object} item - Travel vaccination API record
 * @param {string} slug - URL slug
 * @param {string} [baseUrl] - Shop base URL (REACT_APP_BASE_URL)
 * @returns {object|null}
 */
export function buildTravelVaccineSchema(item, slug, baseUrl = process.env.REACT_APP_BASE_URL) {
  if (!item?.name || item.price == null || !slug || !baseUrl) {
    return null;
  }

  const pageUrl = joinUrl(
    baseUrl,
    `/travel-clinic/vaccinations-by-diseases/${slug}`
  );
  const imageUrl = joinUrl(baseUrl, "/assets/icons/travel-single.png");

  return {
    "@context": "https://schema.org",
    "@type": ["MedicalProcedure", "Service"],
    name: item.name,
    description:
      stripHtml(item.shortDescription || item.description || "") || undefined,
    url: pageUrl,
    image: imageUrl,
    identifier: item.unique_code || slug,
    provider: MPC_MEDICAL_ORGANIZATION,
    offers: {
      "@type": "Offer",
      url: pageUrl,
      priceCurrency: "GBP",
      price: String(item.price),
      availability: "https://schema.org/InStock",
    },
  };
}
